import React from 'react';
import { useSearchParams } from 'react-router-dom';
import PreFormWizardWithCategory from '@/features/submission_forms/PreFormWizardWithCategory';
import PreFormWizardWithSubCategory from '@/features/submission_forms/PreFormWizardWithSubCategory';

const SitesNew: React.FC = () => {
  const [searchParams] = useSearchParams();
  const ownerId = searchParams.get('owner_id');

  // With a known study (owner_id present), the site's EAP status is derived from the
  // study, so the subcategory question is skipped. Without one, the site would be
  // orphaned — keep asking, and show the discouragement banner.
  if (ownerId) {
    return (
      <PreFormWizardWithSubCategory
        category="New Site/Investigator"
        pageTitle="New Site"
        backPath={`/studies/${ownerId}`}
      />
    );
  }

  return (
    <PreFormWizardWithCategory
      category="New Site/Investigator"
      pageTitle="New Site"
      backPath="/sites"
      warnIfNoOwner
    />
  );
};

export default SitesNew;
